import { get } from 'lodash';

import { setJWT, setJWTRefresh } from 'utils/cookies';

// NOTE: 10.0.3.2 is genymotion bridge's link to localhost
// If you are using any other local host URLs add it here
const allDevURLs = ['localhost', '10.0.3.2', '192.168'];

const addLocalhostEnvCookie = client => {
  // intercept responses to see whether there's jwt and jwt refresh inside
  // if so set it for the localhost environment
  client.interceptors.response.use(response => {
    if (
      __DEV__ &&
      window.location.hostname &&
      allDevURLs.some(t => window.location.hostname.includes(t))
    ) {
      const jwt = get(response, 'data.jwt');
      const jwtRefresh = get(response, 'data.jwtRefresh');
      const shouldRedirect = get(response, 'data.shouldRedirect');

      if (jwt) {
        setJWT({ value: jwt, redirect: shouldRedirect });
      }

      if (jwtRefresh) {
        setJWTRefresh({ value: jwtRefresh });
      }
    }
    return response;
  });

  return client;
};

export default addLocalhostEnvCookie;
